import { useSelector } from 'react-redux';
import { selectSeoQuickLinksTabs } from 'shared/selectors/landing';
import { QuickLinksTabsComponent } from '../../components/QuickLinks';
import { TQuickLinksVariant } from './types';

export type { TQuickLinksVariant } from './types';

export const QuickLinks = ({ variant = 'default' }: { variant?: TQuickLinksVariant }) => {
  const tabs = useSelector(selectSeoQuickLinksTabs);

  /* istanbul ignore next */
  if (tabs.length === 0) {
    return null;
  }

  return <QuickLinksTabsComponent tabs={tabs} variant={variant} />;
};
